import { RecurrenceTab } from "./components/event-dialog/RecurrenceTab.mjs";
import { RecurringScopeDialog } from "./components/recurring-scope-dialog/RecurringScopeDialog.mjs";
export const PREMIUM_EVENT_DIALOG_OPTIONAL_RENDERERS = {
  recurrenceTab: RecurrenceTab,
  recurringScopeDialog: RecurringScopeDialog
};